export const colors = {
    primaryDark: "#532fa8",
    primary: "#7543C0",
    primaryLight: "#D5C7EC",
    primarySemiLight: "#9F7CD4",
    primaryLighter: "#EFE8F7",
    ratingColors: ["#bcbcd2", "#C50000", "#FF2323", "#FF6060", "#FFB400", "#A9DB00", "#6DCA00", "#209D00"],
    themeSecondaryDark: "#007BBB",
    themeSecondary: "#009FE3",
    themeSecondaryLight: "#B4E6FB",
    textColor: "#12063C",
    muted: "#4c4b83",
    mutedLight: "#bcbcd2",
    light: "#F9F9FB",
    gridLineColor: "#e4e4ed",
    transparent: "rgba(255,255,255,0.00)"
};
export const radarRatings = ['No Response', 'Strongly Disagree', 'Disagree', 'Slightly Disagree', 'Neutral', 'Slightly Agree', 'Agree', 'Strongly Agree'];
